import type { AppType } from '@amore/api'
import type { ProblemDetails } from '@amore/api/problem'
import { hc } from 'hono/client'

/**
 * The typed client. `AppType` is a type-only import, so nothing from the API
 * ends up in this bundle — but renaming a response field turns this app red.
 *
 * Empty base URL keeps API calls same-origin. Vite proxies /api in dev, and
 * Cloudflare Pages proxies /api to Fly in production.
 */
export const api = hc<AppType>('', {
  init: { credentials: 'include' },
})

/** Every failure the API can produce arrives in this shape. */
export class ApiError extends Error {
  constructor(readonly problem: ProblemDetails) {
    super(problem.detail ?? problem.title)
    this.name = 'ApiError'
  }
}

/**
 * Unwraps a Hono RPC response, preserving the inferred success type and
 * turning problem+json into a typed throw for TanStack Query.
 */
export async function unwrap<T>(promise: Promise<Response>): Promise<T> {
  const response = await promise

  if (!response.ok) {
    throw new ApiError(await readProblem(response))
  }

  return (await response.json()) as T
}

async function readProblem(response: Response): Promise<ProblemDetails> {
  try {
    return (await response.json()) as ProblemDetails
  } catch {
    return {
      type: 'unknown-error',
      title: 'Request failed',
      status: response.status,
    }
  }
}
